<template>
  <div class="jumbotron">
    <div class="container">
      <h1 class="display-3">Speakers Bureau Search Tool</h1>
      <p class="lead">Search through all of the RAINN Speakers Bureau.</p>
      <hr class="my-4" />
      <ul class="nav nav-pills">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            >Actions</a
          >
          <div class="dropdown-menu">
            <a class="dropdown-item" href="#" @click="exportTable"
              >Export table as CSV</a
            >
            <a class="dropdown-item" href="#" @click="exportEmails"
              >Copy Email List</a
            >
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">Search</a>
        </li>
        <li class="nav-item">
          <a
            v-if="this.$store.getters['auth/isSpeaker']"
            class="nav-link"
            href="#"
            @click="() => this.$router.push('/applications/mine')"
            >View Your Applications (Speakers Only)</a
          >
        </li>
        <li class="nav-item">
          <a
            v-if="this.$store.getters['auth/isAdmin']"
            class="nav-link"
            href="#"
            @click="() => this.$router.push('/users')"
            >Manage Users</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link text-danger" href="#" @click="logout">Logout</a>
        </li>
      </ul>
      <hr class="my-4" />
      <Filters
        :filter="filter"
        :keywords="keywords"
        :gender="gender"
        :state="state"
        :age="age"
        :militaryService="militaryService"
        :onFilterValueChanged="onValueChanged"
      />
    </div>
  </div>
</template>

<script>
import Filters from "@/components/Search/Filters";
export default {
  components: {
    Filters
  },
  props: {
    filter: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    keywords: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    gender: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    state: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    age: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    militaryService: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    logout: {
      type: Function,
      required: true,
      default: () => {}
    },
    exportTable: {
      type: Function,
      required: true,
      default: () => {}
    },
    exportEmails: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
